<template>
  <button 
  v-if="isFavourited"
  :disabled="loading"
  @click="unfavourite()"
  class="relative h-[50px] w-[50px] max-[919px]:landscape:w-[34px] max-[919px]:landscape:h-[34px] p-1 rounded flex items-center justify-center transition duration-200 transform hover:scale-105 active:scale-95"
  >
    <svg viewBox="0 0 74 73" class="w-full h-full absolute inset-0">
      <rect fill="#EAEAEA" x="0.81543" width="72.8154" height="72.8154" rx="6" />
      <path d="M37.2229 65.2638C53.1595 65.2638 66.0787 52.3446 66.0787 36.408C66.0787 20.4714 53.1595 7.55225 37.2229 7.55225C21.2863 7.55225 8.36719 20.4714 8.36719 36.408C8.36719 52.3446 21.2863 65.2638 37.2229 65.2638Z" fill="white" />
    </svg>
    <div class="relative z-10 text-[13px] h-full aspect-square flex flex-col items-center justify-center text-center leading-[13px]">
      <Icon name="heroicons:heart-20-solid" class="w-[20px] h-[20px] max-[919px]:landscape:w-[15px] max-[919px]:landscape:h-[15px]" />
    </div>
  </button>
  <button
  v-else
  :disabled="loading"
  @click="favourite()"
  class="relative h-[50px] w-[50px] max-[919px]:landscape:w-[34px] max-[919px]:landscape:h-[34px] p-1 rounded flex items-center justify-center transition duration-200 transform hover:scale-105 active:scale-95"
  >
    <svg viewBox="0 0 74 73" class="w-full h-full absolute inset-0">
      <rect fill="#EAEAEA" x="0.81543" width="72.8154" height="72.8154" rx="6" />
      <path d="M37.2229 65.2638C53.1595 65.2638 66.0787 52.3446 66.0787 36.408C66.0787 20.4714 53.1595 7.55225 37.2229 7.55225C21.2863 7.55225 8.36719 20.4714 8.36719 36.408C8.36719 52.3446 21.2863 65.2638 37.2229 65.2638Z" fill="white" />
    </svg>
    <div class="relative z-10 text-[13px] h-full aspect-square flex flex-col items-center justify-center text-center leading-[13px]">
      <Icon name="heroicons:heart" class="w-[20px] h-[20px] max-[919px]:landscape:w-[15px] max-[919px]:landscape:h-[15px]" />
    </div>
  </button>
</template>

<script setup>
const supabase = useSupabaseClient()
const user = useSupabaseUser()
const messageStore = useMessageStore()
const props = defineProps({
  rudiment: {
    type: Object,
    required: true
  }
})

const buttonClasses = computed(() => {
  return {
    outside: 'nba text-sm bg-gray-200 p-1 aspect-square rounded flex items-center justify-center hover:bg-black cursor-pointer transition duration-200',
    inside: 'bg-white aspect-square rounded-full h-full flex items-center justify-center py-1 px-2 text-xs',
  }
})

const loading = ref(false)
const isFavourited = ref(false)

const { data: getFav, error: getFavError } = await supabase
  .from('favourites')
  .select('*')
  .eq('user', user.value.id)
  .eq('rudiment', props.rudiment.id)
  .maybeSingle()

if (getFav) {
  isFavourited.value = true
}

const favourite = async () => {
  try {
    loading.value = true
    const { error: addFavError } = await supabase
    .from('favourites')
    .insert({
      user: user.value.id,
      rudiment: props.rudiment.id,
      date_created: (new Date()).toISOString()
    })
    if (!addFavError) {
      isFavourited.value = true
      messageStore.message(`Saved to favorites.`, 5, 'success')
    }
  } catch (error) {
    console.error('Error in saveLevel: ', error.message)
  } finally {
    loading.value = false
  }
}

const unfavourite = async () => {
  try {
    const { error: removeFavError } = await supabase
    .from('favourites')
    .delete()
    .match({ user: user.value.id, rudiment: props.rudiment.id })
    if (!removeFavError) {
      isFavourited.value = false
      messageStore.message(`Removed from favorites.`, 5, 'success')
    }
  } catch(error) {
    console.error('Error in saveLevel: ', error.message)
  } finally {
    loading.value = false
  }
}

</script>